import React, { useEffect, useState } from "react";
import { ArrowLeft, Wrench } from "lucide-react";
import { api } from "../lib/api";

// Страница доставки / самовывоза: встраивает сервис приёма заказов UzBiznes на всю страницу.
// Включение/отключение управляется из админки → Сайт (delivery_button_enabled).
const UZBIZNES_EMBED_URL = "https://uzbiznes.com/embed/craft?mode=page";
const BAR_HEIGHT = 48;

export default function Delivery() {
  const [enabled, setEnabled] = useState(null); // null = загрузка
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    document.title = "Доставка / Самовывоз — CRAFT";
    api.get("/site-config")
      .then((r) => setEnabled(r.data?.delivery_button?.enabled !== false))
      .catch(() => setEnabled(true)); // если конфиг недоступен — показываем сервис
  }, []);

  if (enabled === false) {
    return (
      <div className="min-h-screen bg-[#111111] text-white flex flex-col items-center justify-center px-6 text-center" data-testid="delivery-maintenance">
        <div className="w-16 h-16 rounded-2xl bg-[#FEBC10] flex items-center justify-center mb-5">
          <Wrench size={30} className="text-black" />
        </div>
        <h1 className="font-display font-black text-2xl mb-2">Доставка временно недоступна</h1>
        <p className="text-gray-400 text-sm max-w-sm mb-6">
          Ведутся технические работы. Пожалуйста, попробуйте позже или позвоните нам.
        </p>
        <a href="/" className="inline-flex items-center gap-2 bg-[#FEBC10] text-black font-bold px-5 py-3 rounded-xl" data-testid="delivery-back-home">
          <ArrowLeft size={16} /> На сайт CRAFT
        </a>
      </div>
    );
  }

  if (enabled === null) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="w-9 h-9 border-4 border-[#FEBC10] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-white flex flex-col" data-testid="delivery-page">
      <div
        className="flex items-center justify-between px-3 bg-[#111111] text-white shrink-0"
        style={{ height: BAR_HEIGHT }}
      >
        <a href="/" className="inline-flex items-center gap-2 text-sm font-bold hover:text-[#FEBC10] transition-colors" data-testid="delivery-back-link">
          <ArrowLeft size={16} /> На сайт CRAFT
        </a>
        <span className="text-xs font-semibold text-gray-400">Доставка / Самовывоз</span>
      </div>
      <div className="relative flex-1 min-h-0">
        {!loaded && (
          <div className="absolute inset-0 flex items-center justify-center bg-white">
            <div className="w-9 h-9 border-4 border-[#FEBC10] border-t-transparent rounded-full animate-spin" />
          </div>
        )}
        <iframe
          src={UZBIZNES_EMBED_URL}
          title="CRAFT — заказ доставки и самовывоза (UzBiznes)"
          data-testid="uzbiznes-iframe"
          onLoad={() => setLoaded(true)}
          allow="geolocation; payment"
          style={{ width: "100%", height: "100%", border: 0, display: "block" }}
        />
      </div>
    </div>
  );
}
